import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Ohio = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Ohio Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Residential Property Disclosure Form: Mandatory for residential
          sales.
        </Text>

        <Text style={styles.listItem}>
          2. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          3.{' '}
          <Text style={styles.underline}>
            Residential Property Disclosure Form
          </Text>{' '}
          – When selling a residential property, the owner must describe its
          condition using this disclosure statement. It must be provided to the
          buyer before the agreement is signed.
        </Text>
      </View>
    </View>
  );
};

export default Ohio;
